import store from '../services/redux/app/Store';

export { inpNum } from './input';
export const VENDOR_PIM_URL = `${process.env.REACT_APP_API_PIM_URL}`;
export const VENDOR_MC_URL = `${VENDOR_PIM_URL}`;
export const VENDOR_PROMO_MC_URL = `${process.env.REACT_APP_API_PROMO_URL}`;
export const VENDOR_PROMO_URL = `${process.env?.REACT_APP_API_PROMO_URL}`;
export const VENDOR_ECSROW_URL = `${process.env?.REACT_APP_API_ESCROW_URL}`;
export const VENDOR_ECSROW_MC_URL = `${VENDOR_ECSROW_URL}`;
export const VENDOR_OMS_URL = `${process.env?.REACT_APP_API_OMS_URL}`;
export const VENDOR_CMS_URL = `${process.env?.REACT_APP_API_CMS_URL}`;
export const VENDOR_SEARCH_URL = `${process.env?.REACT_APP_API_SEARCH_URL}`;
export const VENDOR_ECOM_URL = `${process.env?.REACT_APP_API_ECOM_URL}/api`;

export const prettyPath = (path: string) => {
  const pathArray = path.split('/').filter((item) => Boolean(item && item !== '/'));

  return pathArray.join('/');
};

export const prettyUrl = (url: string) => {
  const protocol = url.split('://')[0];
  const withoutProtocol = url.split('://')[1];

  url = withoutProtocol.replace(/\/\//, '/');
  url = url.replace(/\/$/, '');

  return `${protocol}://${url}`;
};

export const withPimURL = (path: string) => {
  return prettyUrl(`${VENDOR_PIM_URL}/${prettyPath(path)}`);
};

export const withMcURL = (path: string) => {
  return prettyUrl(`${VENDOR_MC_URL}/${prettyPath(path)}`);
};
export const withPromoURL = (path: string) => {
  return prettyUrl(`${VENDOR_PROMO_MC_URL}/${prettyPath(path)}`);
};
export const withEscrowURL = (path: string, noMcSuffix = false) => {
  return prettyUrl(`${noMcSuffix ? VENDOR_ECSROW_URL : VENDOR_ECSROW_MC_URL}/${prettyPath(path)}`);
};
export const withECOMURL = (path: string) => {
  return prettyUrl(`${VENDOR_ECOM_URL}/${prettyPath(path)}`);
};
export const withOMSURL = (path: string) => {
  return prettyUrl(`${VENDOR_OMS_URL}/${prettyPath(path)}`);
};
export const withCMSURL = (path: string) => {
  return prettyUrl(`${VENDOR_CMS_URL}/${prettyPath(path)}`);
};
export const withSearchURL = (path: string) => {
  return prettyUrl(`${VENDOR_SEARCH_URL}/${prettyPath(path)}`);
};
export const withVendorURL = (path: string) => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  return withMcURL(`${vendorId}/${prettyPath(path)}`);
};

export const vendorUrlRegexPath = (path: string) => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const variableName = 'vendorId';
  const replaceRegex = new RegExp(`:${variableName}`, 'g');
  return path.replace(replaceRegex, (vendorId || '').toString());
};
